import { Button } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useIsMobile } from 'common/hooks/useIsMobile';

export type AdCampaignActionsFooterProps = {
  campaignId?: string;
  isLoading: boolean;
  isDirty: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
};

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
`;
export const AdCampaignActionsFooter = ({
  campaignId,
  isLoading = false,
  isDirty,
  onSubmit,
  onCancel,
}: AdCampaignActionsFooterProps) => {
  const isMobile = useIsMobile();
  const buttonsSize = isMobile ? 'large' : 'small';

  if (!!campaignId) {
    return (
      <ButtonWrapper>
        <Button variant="secondary" size={buttonsSize} onClick={onCancel}>
          <FormattedMessage id="state.cancel" />
        </Button>
        <Button variant="primary" size="small" onClick={onSubmit} loading={isLoading} disabled={isLoading || !isDirty}>
          <FormattedMessage id="campaigns.save-changes" />
        </Button>
      </ButtonWrapper>
    );
  }
  return (
    <Button variant="primary" size="large" stretch onClick={onSubmit} loading={isLoading} disabled={isLoading}>
      <FormattedMessage id="campaigns.form.create-campaign" />
    </Button>
  );
};
